export default "__VITE_ASSET__BjOOE0iG__"